/**
 * Delade KaTeX-optioner för allt som renderas till HTML i tjänsten.
 *
 * Bakgrund (låg-fynd ur /sakerhetskoll 2026-08-25): diagnosanalysen blev den
 * första ytan där en ELEVS fritext renderas i en ANNAN användares webbläsare —
 * läraren ser de vanligaste felsvaren. Det är inte XSS: `trust` är false som
 * default och sätts aldrig, vilket avaktiverar `\href`, `\url` och `\html*`.
 * Men `maxSize` är `Infinity` som default, och ett elevsvar på formen
 * `$\rule{9999em}{9999em}$` renderas då med `height:9999em; width:9999em` —
 * mätt — vilket gör lärarens analyssida oanvändbar för hela gruppen.
 *
 * Varför gränserna sätts GLOBALT och inte som en opt-in-prop på den enda
 * kända otrustade anropsplatsen: en prop måste kommas ihåg av varje framtida
 * renderare, och det är precis den sortens sak som driftar isär. Kontrollerat
 * före beslutet att det är ofarligt för författat innehåll — varken
 * `src/content` eller `prisma/paket` innehåller `\def`, `\newcommand`,
 * `\rule`, `\kern`, `\hspace`, `\raisebox` eller ett enda em-mått. Verifierat
 * att `x^2+15x` renderas oförändrat med `maxSize: 10`.
 *
 * Nya renderare ska importera den här konstanten i stället för att skriva
 * `{ throwOnError: false }` för hand.
 */
export const KATEX_OPTIONER = {
  /** Ett trasigt uttryck ska visas som text, inte krascha sidan. */
  throwOnError: false,
  /** Tak i em för användarangivna mått (`\rule`, `\kern`, `\raisebox` …).
   *  10em är långt över allt vi själva sätter, och klämmer 9999em → 10em. */
  maxSize: 10,
  /** Tak för makroexpansioner. Skyddar mot `\def`-bomber i elevtext; vårt eget
   *  innehåll definierar inga makron alls. */
  maxExpand: 100,
} as const;
